
export const FacturaImagenDTO = (fileName:string = "",fileBase64:string = "" ) =>({
    ImgBase64: fileBase64,
    NombreNuevaImagen: fileName,
})

export const FacturaImagenOCRDTO = (fileName:string = "",fileBase64:string = "" ,precupon=0,comercio=0) =>({
     IdPreCupon: precupon,        
    Id_Comercio: comercio,        
    ImgBase64: fileBase64,          
    NombreNuevaImagen: fileName,  
})